import type { ThemeData } from '../models';
import { defaultTheme } from './defaultTheme';

export const truFitTheme: ThemeData = {
  ...defaultTheme,
  navImageBlocks: {
    default: {
      imageBlocks: [
        {
          title: 'iD Stain Whitening Mouthwash',
          link: '/products/id-stain-mouthwash/',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Starter_Bundle_V2-_M.png?v=1784864971',
            alt: 'iD Stain Whitening Mouthwash',
            height: 240,
            width: 366,
          },
        },
        {
          title: 'Tru-Fit Manual Toothbrush',
          link: '/products/tru-fit-manual-toothbrush/white',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Tru-fit-white-toothbrush.png?v=1791416126',
            alt: 'Tru-Fit Manual Toothbrush',
            height: 240,
            width: 366,
          },
        },
      ],
    },
  },
};
